// extracted by mini-css-extract-plugin
module.exports = {"waiting":"style_waiting__3ik-N","waiting__title":"style_waiting__title__1xShd","waiting__text":"style_waiting__text__3ZXqF"};